import { func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import withProps from 'recompose/withProps'

import View from '../View'

const ActButtons = scope(
  consumeProps({
    updateUsing: func.isRequired,
    updateGridValues: func.isRequired,
    undo: func.isRequired,
    save: func.isRequired,
    gotoDocList: func.isRequired,
  }),

  withProps(
    ({ updateUsing, updateGridValues, undo, gotoDocList, save }) => ({
      options: [
        { key: 'cancel', name: '取消選取', onClick: () => updateUsing('fromCell', null) },
        { key: 'clear', name: '全部清除', onClick: () => updateGridValues({ }) },
        { key: 'undo', name: '復原', onClick: undo },
        { key: 'save', name: '儲存', onClick: save },
        { key: 'cancel', name: '取消', onClick: () =>
          (confirm('確定不儲存資料離開?') ? gotoDocList() : null),
        },
      ],
      using: '',
    })
  ),

  exposeProps([
    'options',
    'using',
  ]),
)(View)

ActButtons.displayName = 'ActButtons'

export default ActButtons



// WEBPACK FOOTER //
// ./src/components/RangeEditor/SettingButtons/ActButtons/index.js